import EventEmitter from 'owa-event-emitter';

export const mailEventEmitter = new EventEmitter();
export const TRIGGER_MAIL_LIST_SCROLL_TO_TOP = 'triggerMailListScrollToTop';
export const TRIGGER_MAIL_LIST_SCROLL_TO_FOCUS_ITEM = 'triggerMailListScrollToFocusItem';
